import { Badge } from "@comps/ui/badge";
import { AllRightOptions, isOptionAllowed, RightAccess, RightOption } from "@dto/Users";
import { TW_RoleDetailsRightOptionChip, TW_RoleDetailsRightOptionChipEmpty } from "@utils/twClasses";
import { useTranslation } from "react-i18next";

interface RightOptionChipsProps {
  level: RightAccess;
  options: RightOption[];
}

/** Summary of the options effectively granted by a right (add, delete, export), or "no option". */
function RightOptionChips({ level, options }: RightOptionChipsProps) {
  const { t } = useTranslation();
  const effective = AllRightOptions.filter(option => options.includes(option) && isOptionAllowed(option, level));

  if (effective.length === 0) {
    return <Badge variant="outline" className={TW_RoleDetailsRightOptionChipEmpty}>{t("right.option.chip.none")}</Badge>;
  }
  return (
    <>
      {effective.map(option => (
        <Badge key={option} variant="secondary" className={TW_RoleDetailsRightOptionChip}>{t(`right.option.chip.${option}`)}</Badge>
      ))}
    </>
  );
}

export default RightOptionChips;
